import React from 'react';
import { IOptionBase } from '../models';
import { GroupBase, OptionsOrGroups } from 'react-select';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';

import styles from './FormatGroupLabel.scss';

export interface IGroupedOption {
  label: string;
  options?: OptionsOrGroups<IOptionBase, GroupBase<IOptionBase>>;
}

export const FormatGroupLabel = (data: IGroupedOption) => {
  const groupLabel = data.label || '';
  const firstLetter = groupLabel.charAt(0).toUpperCase();
  const otherText = groupLabel.slice(1);
  return (
    <Box
      paddingLeft={{ MOBILE: 16, DESKTOP: 4 }}
      paddingTop={{ MOBILE: 12 }}
      paddingBottom={{ MOBILE: 12 }}
      data-elem="select-format-group-label"
    >
      <Text id="groupLabelFirstLetter" size="caption" weight="bold" color={'basicGreySemiDark'}>
        {firstLetter}
      </Text>
      <Text
        id="groupLabelOtherText"
        className={styles.lowerCaseText}
        size="caption"
        weight="bold"
        color={'basicGreySemiDark'}
      >
        {otherText}
      </Text>
    </Box>
  );
};
